import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_imagemaint } from "../shared/data.service";

import { wsImageLibraryListInfo } from "../shared/wsImageLibraryListInfo";
import { wsImageGroupInfo } from "../shared/wsImageGroupInfo";
import { wsImageLibraryCopyParm } from "../shared/wsImageLibraryCopyParm";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./imagecopy.component.html",
	styleUrls: ["./imagecopy.component.css"],
})
export class ImageCopyComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_imagemaint, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public SelectedImageLibraryItem: wsImageLibraryListInfo;

	public lstImageGroup: wsImageGroupInfo[] = [];
	public SelectedImageGroup: wsImageGroupInfo;

	public NewImageLibraryItemName: string = "";
	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.SelectedImageLibraryItem = this.dialogConfig.data.SelectedItem;
		this.lstImageGroup = this.dialogConfig.data.lstImageGroup;
		this.NewImageLibraryItemName = "Copy of " + this.SelectedImageLibraryItem.ImageLibraryItemName;

		//
		//	Default select
		//
		this.lstImageGroup.forEach((item) => {
			if (item.ImageLibraryGroupID == this.SelectedImageLibraryItem.ImageLibraryGroupID) {
				this.SelectedImageGroup = item;
			}
		});

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onImageGroupChange
	//
	//-----------------------------------------------------------------------------------------------------
	onImageGroupChange(value) {
		this.SelectedImageGroup = value;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCopy
	//
	//-----------------------------------------------------------------------------------------------------
	onCopy() {
		let parms: wsImageLibraryCopyParm = {
			ImageLibraryID: this.SelectedImageLibraryItem.ImageLibraryID,
			ImageLibraryGroupID: this.SelectedImageGroup.ImageLibraryGroupID,
			NewImageLibraryItemName: this.NewImageLibraryItemName.trim(),
		};

		this.isBusy = true;
		this.dataService.ImageLibraryCopy(parms).subscribe((data) => this.ImageLibraryCopy_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryCopy_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryCopy_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
